module.exports = __webpack_public_path__ + "img/TIK.4936a761.svg";